/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const APPROVE_PORTFOLIO = gql`
mutation VerifyStudentPortfolio($filter: UniqStudPortfolioFilterInput!, $data: VerifyStudPortfolioInput) {
  verifyStudentPortfolio(filter: $filter, data: $data) {
    id
    _id
    uuid
    name
    display
    socialLinks
    description
    logo
    bannerImage
    state
    email
    credentials
    userGroup
    feedback
    recommendation
    goal
    createdAt
    updatedAt
  }
}
`;
